__turbopack_context__.v({
  "feedback": "feedbacks-module-scss-module__b3Wxta__feedback",
  "feedbackAuthor": "feedbacks-module-scss-module__b3Wxta__feedbackAuthor",
  "feedbackCard": "feedbacks-module-scss-module__b3Wxta__feedbackCard",
  "feedbackLogo": "feedbacks-module-scss-module__b3Wxta__feedbackLogo",
  "feedbackText": "feedbacks-module-scss-module__b3Wxta__feedbackText",
  "feedbacks": "feedbacks-module-scss-module__b3Wxta__feedbacks",
  "feedbacksWrp": "feedbacks-module-scss-module__b3Wxta__feedbacksWrp",
  "grab": "feedbacks-module-scss-module__b3Wxta__grab",
  "grid": "feedbacks-module-scss-module__b3Wxta__grid",
  "modernCard": "feedbacks-module-scss-module__b3Wxta__modernCard",
  "sliderFeedbacks": "feedbacks-module-scss-module__b3Wxta__sliderFeedbacks",
  "wrapperSliderFeedbacks": "feedbacks-module-scss-module__b3Wxta__wrapperSliderFeedbacks",
});
